import * as ml from '../services/ml';

export default {
  namespace: 'mlEC',

  state: {
    getGradeChange: null,
    getGradeChangeMolding: null,
    getMemberDetail: null,
    getIntegralHistory: null,
    getBindRecord: null,
    getBasicInformation: null,
    getConsumptionRecord: null,
    getConsumptionRecordDetail: null,
    editMember: null,
    dataChart1: null,
    dataChart2: null,
    dataChart3: null,
    dataChart4: null,
    dataChart5: null,
    dataChart6: null,
  },

  effects: {
    //等级变化
    *getGradeChange({ payload: { values } }, { call, put }) {
      const response = yield call(ml.getGradeChange, values);
      yield put({
        type: 'save',
        payload: {
          getGradeChange: response?.data,
        },
      });
    },
    //等级变化
    *getGradeChangeMolding({ payload: { values } }, { call, put }) {
      const response = yield call(ml.getGradeChangeMolding, values);
      yield put({
        type: 'save',
        payload: {
          getGradeChangeMolding: response?.data,
        },
      });
    },
    //经验列表
    *getExperienceChange({ payload: { values } }, { call, put }) {
      const response = yield call(ml.getExperienceChange, values);
      yield put({
        type: 'save',
        payload: {
          getExperienceChange: response?.data,
        },
      });
    },
    //会员详情
    *getMemberDetail({ payload: { values }, callback }, { call, put }) {
      if (values.memberCode && values.memberCode.length === 11) {
        values.memberCode = null;
      }
      const response = yield call(ml.getMemberDetail, values);
      yield put({
        type: 'save',
        payload: {
          getMemberDetail: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //编辑会员
    *editMember({ payload: { values }, callback }, { call, put }) {
      const response = yield call(ml.editMember, values);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {
          editMember: response,
        },
      });
    },

    //积分历史
    *getIntegralHistory({ payload: { values } }, { call, put }) {
      const response = yield call(ml.getIntegralHistory, values);
      yield put({
        type: 'save',
        payload: {
          getIntegralHistory: response?.data,
        },
      });
    },

    //绑定变化记录
    *getBindRecord({ payload: { values } }, { call, put }) {
      const response = yield call(ml.getBindRecord, values);
      yield put({
        type: 'save',
        payload: {
          getBindRecord: response, //后端接口直接返回data,未用data包裹和pagenation信息
        },
      });
    },
    //消费记录
    *getConsumptionRecord({ payload: { values } }, { call, put }) {
      const response = yield call(ml.getConsumptionRecord, values);
      yield put({
        type: 'save',
        payload: {
          getConsumptionRecord: response?.data,
        },
      });
    },
    //消费记录详情
    *getConsumptionRecordDetail({ payload: { values } }, { call, put }) {
      const response = yield call(ml.getConsumptionRecordDetail, values);
      yield put({
        type: 'save',
        payload: {
          getConsumptionRecordDetail: response,
        },
      });
    },
    // 会员层级charts
    *funChart1({ payload: { values }, callback }, { call, put }) {
      const response = yield call(ml.apiChart1, values);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {
          dataChart1: response?.data,
        },
      });
    },
    // 每月消费金额笔数
    *funChart2({ payload: { values }, callback }, { call, put }) {
      const response = yield call(ml.apiChart2, values);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {
          dataChart2: response?.data,
        },
      });
    },
    // 会员积分使用比例
    *funChart3({ payload: { values }, callback }, { call, put }) {
      const response = yield call(ml.apiChart3, values);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {
          dataChart3: response?.data,
        },
      });
    },
    // 会员消费比例：按渠道
    *funChart4({ payload: { values }, callback }, { call, put }) {
      const response = yield call(ml.apiChart4, values);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {
          dataChart4: response?.data,
        },
      });
    },
    // 会员等级变化史
    *funChart5({ payload: { values }, callback }, { call, put }) {
      const response = yield call(ml.apiChart5, values);
      if (callback && typeof callback === 'function') {
        console.log(response);
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {
          dataChart5: response?.data,
        },
      });
    },
    // 会员优惠券记录列表
    *getCouponRecordList({ payload: { values }, callback }, { call, put }) {
      const response = yield call(ml.getCouponRecordList, values);
      yield put({
        type: 'save',
        payload: {
          couponRecordList: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    // 每月金额变化
    *funChart6({ payload: { values }, callback }, { call, put }) {
      const response = yield call(ml.apiChart6, values);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {
          dataChart6: response?.data,
        },
      });
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history }) {
      return history.listen(() => {});
    },
  },
};
